import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IonContent, IonTextarea} from '@ionic/angular';
import {ChatMessage, ChatService, UserInfo} from '../../../providers/chat-service';
import {Events} from '../../../providers/events';
import {ViewController} from '../../../providers/view-controller.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-chat',
  templateUrl: 'chat.html',
  styleUrls: ['./chat.scss']
})
export class ChatPageComponent implements OnInit, OnDestroy {
  @Input() toUserId;
  @Input() toUserName;

  @ViewChild(IonContent) content: IonContent;
  @ViewChild(IonTextarea) textarea: IonTextarea;
  msgList: ChatMessage[] = [];
  user: UserInfo;
  toUser: UserInfo;
  editorMsg = '';
  showEmojiPicker = false;
  private chatReceived:Subscription;

  constructor(private chatService: ChatService,
              private events: Events, private viewCtrl: ViewController) {
  }

  ngOnInit() {

    const chatReceived = (msg: any) => {
      this.pushNewMsg(msg);
    };

  
    this.chatReceived = this.events.subscribe('chat:received', chatReceived);

    this.toUser = {
      id: this.toUserId,
      name: this.toUserName,
    };
    // Get mock user information
    this.chatService.getUserInfo()
      .then((res) => {
        this.user = res;
      });
  }

  ngOnDestroy(): void {
    this.chatReceived.unsubscribe();
  }

  ionViewDidEnter() {
    // get message list
    this.getMsg();
  }

  onFocus() {
    this.showEmojiPicker = false;
    this.scrollToBottom();
  }

  switchEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
    if (!this.showEmojiPicker) {
      this.focus();
    } else {
      this.setTextareaScroll();
    }
    this.scrollToBottom();
  }


  getMsg() {
    // Get mock message list
    return this.chatService
      .getMsgList(this.toUser.id)
      .then(res => {
        this.msgList = res;
        this.scrollToBottom();
      });
  }

  /**
   * sendMsg
   */
  sendMsg() {
    if (!this.editorMsg.trim()) {
      return;
    }

    // Mock message
    const id = Date.now().toString();
    const newMsg: ChatMessage = {
      messageId: Date.now().toString(),
      userId: this.user.id,
      userName: this.user.name,
      userAvatar: this.user.avatar,
      toUserId: this.toUser.id,
      time: Date.now(),
      message: this.editorMsg,
      status: 'pending'
    };

    this.pushNewMsg(newMsg);
    this.editorMsg = '';

    if (!this.showEmojiPicker) {
      this.focus();
    }

    this.chatService.sendMsg(newMsg)
      .then(() => {
        const index = this.getMsgIndexById(id);
        if (index !== -1) {
          this.msgList[index].status = 'success';
        }
      });
  }

  /**
   * pushNewMsg
   * msg
   */
  pushNewMsg(msg: ChatMessage) {
    const userId = this.user.id;
    const toUserId = this.toUser.id;
    // Verify user relationships

    if (msg.userId === userId && msg.toUserId === toUserId) {
      this.msgList.push(msg);
    } else if (msg.toUserId === userId && msg.userId === toUserId) {
      this.msgList.push(msg);
    }
    this.scrollToBottom();
  }

  getMsgIndexById(id: string) {
    return this.msgList.findIndex(e => e.messageId === id);
  }

  scrollToBottom() {
    setTimeout(() => {
      if (this.content.scrollToBottom) {
        try {
          this.content.scrollToBottom();
        } catch (x) {
          console.log(x);
        }

      }
    }, 400);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  private focus() {
    if (this.textarea) {
      this.textarea.setFocus();
    }
  }

  private setTextareaScroll() {
   // const textarea = this.messageInput.nativeElement;
   // textarea.scrollTop = textarea.scrollHeight;
  }
}
